__turbopack_context__.v({
  "applyBtn": "WJobOffers-module__C3f4eW__applyBtn",
  "applyWrap": "WJobOffers-module__C3f4eW__applyWrap",
  "body": "WJobOffers-module__C3f4eW__body",
  "card": "WJobOffers-module__C3f4eW__card",
  "cardDesc": "WJobOffers-module__C3f4eW__cardDesc",
  "cardTitle": "WJobOffers-module__C3f4eW__cardTitle",
  "ctaBtn": "WJobOffers-module__C3f4eW__ctaBtn",
  "ctaCard": "WJobOffers-module__C3f4eW__ctaCard",
  "ctaHeading": "WJobOffers-module__C3f4eW__ctaHeading",
  "heading": "WJobOffers-module__C3f4eW__heading",
  "inner": "WJobOffers-module__C3f4eW__inner",
  "list": "WJobOffers-module__C3f4eW__list",
  "pill": "WJobOffers-module__C3f4eW__pill",
  "pillList": "WJobOffers-module__C3f4eW__pillList",
  "root": "WJobOffers-module__C3f4eW__root",
  "tech": "WJobOffers-module__C3f4eW__tech",
  "techList": "WJobOffers-module__C3f4eW__techList",
});
